import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { PatientDemographicsService } from '../../patientDemographics/services/patientDemographics.service'
import { setEmailTypeOptions } from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'

export function* getEmailTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const patientDemographicsService = new PatientDemographicsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([
      patientDemographicsService,
      patientDemographicsService.getEmailTypeOptions,
    ])
    const { entity } = response
    yield put(setEmailTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getEmailTypeOptions() error: ${e}`))
  }
}

export function* getEmailTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getEmailTypeOptions)
}
